import { useEffect, useMemo, useState } from "react";
import { Box, Stack, TextField, Button, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";


import BreadcrumbsBar from "../../../../../component/common/BreadcrumbsBar";
//import PageHeader from "../../../../component/common/PageHeader";

import ReportContainer from "../../../component/ReportContainer";
import ReportHeader from "../../../component/ReportHeader";
import ReportToolbar from "../../../component/ReportToolbar";
import ReportTitle from "../../../component/ReportTitle";
import ReportActions from "../../../component/ReportActions";
import ReportLoading from "../../../component/ReportLoading";
import ReportNoData from "../../../component/ReportNoData";
import { MenuItem } from "@mui/material";
import WGRViewer from "./dwdViewer";
import { dwsDetailsProcedure } from "../../../../../services/reportService";
import generateWGRPDF from "./pdfreport/dwdgeneratePDF";

import { useLocation } from "react-router-dom";

import SearchIcon from "@mui/icons-material/Search";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function DWDPage() {





  const location = useLocation();

  const report = location.state || {
    reportType: "DWD",
    title: "Demand Wise Summery Reports",
  };

  const { reportType, title } = report;

  const today = new Date();



  const month = location.state.month;
  const year = location.state.year;




  const [rows, setRows] = useState([]);

  const [loading, setLoading] = useState(false);

  const monthName = useMemo(
    () => months[month - 1],
    [month]
  );

  const loadReport = async () => {
    try {
      setLoading(true);

      const res = await dwsDetailsProcedure(month, year);

      setRows(res.data.data || []);
      // console.log(res);

    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    loadReport();
  };

  const handlePrint = () => {
    window.print();

    setTimeout(() => {
      setRows([]);
    }, 500);
  };


  const grandTotal = useMemo(() => {
    return rows.reduce(
      (sum, row) => {

        const dl = Number(row["DIRECT LABOUR"] || 0);
        const ds = Number(row["DIRECT STORE"] || 0);
        const ocl = Number(row["ON COST LABOUR"] || 0);
        const ocs = Number(row["ON COST STORE"] || 0);
        const total = dl + ds + ocl + ocs;


        return {
          dl: sum.dl + dl,
          ds: sum.ds + ds,
          ocl: sum.ocl + ocl,
          ocs: sum.ocs + ocs,
          total: sum.total + total,

        };
      },
      {
        dl: 0,
        ds: 0,
        ocl: 0,
        ocs: 0,
        total: 0,






      }
    );
  }, [rows]);

  const handlePdf = () => {
    generateWGRPDF(
      reportType,
      title,
      grandTotal,
      rows,
      "",
      monthName,

      year
    );
  };

  const handleExcel = () => {
    console.log("Generate Excel");
  };


  useEffect(() => {
    // Optional: Clear previous report
    setRows([]);

    // Load report if you want automatically
    loadReport();

  }, [reportType]);




  return (
    <Box >

      <BreadcrumbsBar page={title} />


      {/* Search Panel */}




      {/* Report */}

      <ReportContainer>


        <ReportToolbar>

          <ReportTitle
            title={title}
            subtitle={`${monthName} ${year}`}
          />

          <Box className="no-print">
            <ReportActions
              onRefresh={handleRefresh}
              onPrint={handlePrint}
              onPdf={handlePdf}
              onExcel={handleExcel}
            />
          </Box>



        </ReportToolbar>

        {loading ? (
          <ReportLoading />
        ) : rows.length === 0 ? (
          <ReportNoData text="Click Generate to view report." />
        ) : (
          <WGRViewer
            rows={rows}
            grandTotal={grandTotal}
            summary=""
          />
        )}

      </ReportContainer>

    </Box>
  );
}